/**
 * An account's display name: **Bank/Type-User** ("HDFC/Savings-Pritesh").
 *
 * Shared by web (Accounts tiles, entry form, account page) and mobile
 * (Dashboard tiles) so an account is called the same thing everywhere —
 * the phone used to show the raw Wallet nickname ("HDFC-PRITESH").
 */
const BANK_SHORT: Record<string, string> = {
  hdfc: "HDFC",
  "hdfc bank": "HDFC",
  sbi: "SBI",
  "state bank of india": "SBI",
  kotak: "Kotak",
  "kotak mahindra bank": "Kotak",
  cbi: "CBI",
  "central bank of india": "CBI",
  icici: "ICICI",
  "icici bank": "ICICI",
};

const NO_BANK = new Set(["", "fd", "rd", "cash", "default savings"]);

const TYPE_LABEL: Record<string, string> = {
  SAVINGS: "Savings",
  CURRENT: "Current",
  FD: "FD",
  RD: "RD",
  CASH: "Cash",
  CREDIT_CARD: "Credit card",
};

/** Short bank name, or null for placeholder banks ("FD", "Cash"). */
export function bankShortName(bankName: string, householdShort?: string): string | null {
  const key = (bankName ?? "").trim().toLowerCase();
  if (NO_BANK.has(key)) return null;
  return householdShort ?? BANK_SHORT[key] ?? bankName.trim().replace(/\s+Bank$/i, "");
}

export function accountTypeLabel(accountType: string): string {
  return TYPE_LABEL[(accountType ?? "").toUpperCase()] ?? accountType;
}

export function accountTileName(
  bankName: string,
  accountType: string,
  ownerName: string,
  householdShort?: string,
): string {
  const owner = (ownerName ?? "").trim().split(/\s+/)[0] ?? "";
  const type = accountTypeLabel(accountType);
  const bank = bankShortName(bankName, householdShort);
  return `${bank ? `${bank}/` : ""}${type}-${owner}`;
}
